<app-overflow-wrapper-x>
  <div class="flex md:flex-wrap gap-2 [&_.playlist-tag-button]:bg-white">
    <div *ngFor="let playlistsTag of playlistsTags$ | async">
      <app-playlist-tag-button (click)="clickTag(playlistsTag)">{{ playlistsTag }}</app-playlist-tag-button>
    </div>
  </div>
</app-overflow-wrapper-x>
